import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Divider from '@material-ui/core/Divider'

import {
  Alert,
  DescriptionItem,
  LoadingButton,
  Subtitle,
} from '../../../../components'
import { subscriptionService } from '../../../../services'

const useStyles = makeStyles(() => ({
  divider: {
    margin: '24px 0 16px',
  },
  download: {
    marginTop: '16px',
    textAlign: 'center',
  },
  subtitle: {
    fontWeight: 600,
    marginBottom: '0px',
  },
}))

const ReturnReceipt = ({ receipt, credentials }) => {
  const classes = useStyles()

  const [loading, setLoading] = useState(false)

  const { firstOption } = receipt

  const tryToGetPdf = async () => {
    setLoading(true)

    await subscriptionService.getReturnReceiptPdf(
      credentials.cpf,
      credentials.cpfResponsible,
      receipt.uuid
    )

    setLoading(false)
  }

  return (
    <>
      <Grid item xs={12}>
        <Alert>
          Atenção! A efetivação da matrícula na escola de 1ª opção está
          condicionada à disponibilidade de vaga.
        </Alert>
      </Grid>

      <Grid item xs={12}>
        <Subtitle className={classes.subtitle}>
          Solicitação de retorno à lista de suplência
        </Subtitle>
      </Grid>

      <DescriptionItem
        label="Data e hora da solicitação"
        value={receipt.returnedAtFormatted}
        md={4}
      />
      <DescriptionItem label="IP Público" value={receipt.ip} md={4} />
      <DescriptionItem label="Protocolo" value={receipt.protocol} md={4} />

      <Grid item xs={12}>
        <Divider className={classes.divider} />
      </Grid>

      <Grid item xs={12}>
        <Subtitle className={classes.subtitle}>
          Escola de 1ª opção (retorno à lista de suplência)
        </Subtitle>
      </Grid>

      <DescriptionItem label="Escola" value={firstOption.schoolName} md={6} />
      <DescriptionItem label="Turno" value={firstOption.shiftName} md={3} />
      <DescriptionItem
        label="Oferta"
        value={firstOption.curriculumName}
        md={3}
      />

      <DescriptionItem
        label="Modalidade"
        value={firstOption.levelName}
        md={6}
      />
      <DescriptionItem
        label="Ano de escolaridade"
        value={firstOption.degreeName}
        md={3}
      />
      <DescriptionItem label="Cidade" value={firstOption.cityName} md={3} />

      <Grid item xs={12} className={classes.download}>
        <LoadingButton
          disabled={loading}
          loading={loading}
          onClick={tryToGetPdf}
        >
          Baixar comprovante em PDF
        </LoadingButton>
      </Grid>
    </>
  )
}

export default ReturnReceipt
